<template>
  <div class="step">
    <a-steps
      class="step-list"
      :current="current"
      label-placement="vertical"
      :status="active===current?'process':'finish'"
      @change="changeValue(current)"
    >
      <!-- <a-step v-for="item in steps" :key="item.title" :title="item.title" :status="status" /> -->
      <template v-if="steps.length===stepList.length">
        <a-step :status="active===0?'process':'finish'" title="基本信息维护" @click.native="stepChange(1)" />
        <a-step :status="active===1?'process':'finish'" title="场地信息维护" @click.native="stepChange(2)" />
        <a-step :status="active===2?'process':'finish'" title="机位信息维护" @click.native="stepChange(3)" />
        <a-step :status="active===3?'process':'finish'" title="监控信息维护" @click.native="stepChange(4)" />
      </template>
      <template v-else>
        <a-step title="基本信息维护" @click.native="stepChange(1)">
          <a-icon v-if="current<0&&current!==0" slot="icon" type="right-circle" style="font-size:30px" />
        </a-step>
        <a-step title="场地信息维护" @click.native="stepChange(2)">
          <a-icon v-if="current<1&&current!==1" slot="icon" type="right-circle" style="font-size:30px" />
        </a-step>
        <a-step title="机位信息维护" @click.native="stepChange(3)">
          <a-icon v-if="current<2&&current!==2" slot="icon" type="right-circle" style="font-size:30px" />
        </a-step>
        <a-step title="监控信息维护" @click.native="stepChange(4)">
          <a-icon v-if="current!==3" slot="icon" type="right-circle" style="font-size:30px" />
        </a-step>
      </template>
    </a-steps>
    <div v-show="current===0" class="info-base">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="150px" class="base-form" label-position="right">
        <el-form-item label="场地联系人：" prop="linkMan">
          <el-input v-model.trim="ruleForm.linkMan" clearable maxlength="20" />
        </el-form-item>
        <el-form-item label="联系方式：" prop="linkPhone">
          <el-input
            v-model.trim="ruleForm.linkPhone"
            clearable
            maxlength="20"
          />
        </el-form-item>
      </el-form>
    </div>
    <div v-show="current===1" class="info-base">
      <div>
        场地：<el-button size="small" type="primary" icon="el-icon-plus" @click="openUpdate()">新增场地</el-button>
      </div>
      <div class="info-base-table">
        <el-table
          :data="bidData"
          border
          style="width: 100%"
          :header-cell-style="{
            background:'#D9E1E7',
            color:'#000'
          }"
          align="center"
        >
          <el-table-column
            label="序号"
            width="50"
            align="center"
          >
            <template scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="filedName"
            label="场地名称"
            align="center"
          />
          <el-table-column
            prop="fieldCode"
            label="场地编号"
            align="center"
          />
          <el-table-column
            prop="seatNum"
            label="机位数"
            align="center"
          />
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="openUpdate(scope.row.id)">修改</el-button>
              <el-button type="text" @click="handleDelete(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <pagination
            v-show="bidTotal>7"
            class="limit"
            :page-sizes="[7, 14, 21, 28,35]"
            :total="bidTotal"
            :page.sync="bidQuery.page"
            :limit.sync="bidQuery.limit"
            @pagination="getBidData"
          />
        </div>
      </div>
    </div>
    <div v-show="current===2" class="info-base">
      <div>
        机位信息：<el-button size="small" type="primary" icon="el-icon-plus" @click="openSeatUpdate()">新增机位</el-button>
      </div>
      <div class="info-base-table over">
        <el-table
          :data="seatData"
          border
          style="width: 100%"
          :header-cell-style="{
            background:'#D9E1E7',
            color:'#000'
          }"
          align="center"
        >
          <el-table-column
            label="序号"
            width="50"
            align="center"
          >
            <template scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="filedName"
            label="场地名称"
            align="center"
          />
          <el-table-column
            prop="seatName"
            label="机位名称"
            align="center"
          />
          <el-table-column
            prop="seatCode"
            label="机位编号"
            align="center"
          />
          <el-table-column
            prop="seatMac"
            label="机位物理地址"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="seatStatus"
            label="状态"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.seatStatus == 0" class="open">启用</span>
              <span v-if="scope.row.seatStatus == 1" class="close">停用</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="openSeatUpdate(scope.row.id)">修改</el-button>
              <el-button type="text" @click="handleSeatDelete(scope.row.id)">删除</el-button>
              <el-button v-if="scope.row.seatStatus ===0" type="text" @click="handleSeatClose(scope.row)">停用</el-button>
              <el-button v-else type="text" @click="handleSeatClose(scope.row)">启用</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <pagination
            v-show="seatTotal>7"
            class="limit"
            :page-sizes="[7, 14, 21, 28,35]"
            :total="seatTotal"
            :page.sync="seatQuery.page"
            :limit.sync="seatQuery.limit"
            @pagination="getSeatData"
          />
        </div>
      </div>
    </div>
    <div v-show="current===3" class="info-base">
      <div>
        监控信息：
        <el-button size="small" type="primary" icon="el-icon-plus" @click="openMonitorUpdate()">新增监控</el-button>
      </div>
      <div class="info-base-table over">
        <el-table
          :data="monitorData"
          border
          style="width: 100%"
          :header-cell-style="{
            background:'#D9E1E7',
            color:'#000'
          }"
          align="center"
        >
          <el-table-column
            label="序号"
            width="50"
            align="center"
          >
            <template scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="filedName"
            label="场地名称"
            align="center"
          />
          <el-table-column
            prop="cameraName"
            label="监控名称"
            align="center"
          />
          <el-table-column
            prop="cameraCode"
            label="监控编号"
            align="center"
            show-overflow-tooltip
          />
          <el-table-column
            prop="cameraUrl"
            label="监控地址"
            align="center"
            show-overflow-tooltip
          />

          <el-table-column
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" @click="openMonitorUpdate(scope.row.id)">修改</el-button>
              <el-button type="text" @click="handleMonitorDelete(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <pagination
            v-show="monitorTotal>7"
            class="limit"
            :page-sizes="[7, 14, 21, 28,35]"
            :total="monitorTotal"
            :page.sync="monitorQuery.page"
            :limit.sync="monitorQuery.limit"
            @pagination="getMonitorData"
          />
        </div>
      </div>
    </div>
    <div class="steps-action step-btn">
      <el-button :disabled="current===0" @click="prev">
        上一步
      </el-button>
      <el-button
        v-if="current < steps.length - 1"
        type="primary"
        :loading="btnload"
        @click="next"
      >
        下一步
      </el-button>
      <el-button
        v-if="current == steps.length - 1"
        type="primary"
        @click="finish"
      >
        完成
      </el-button>
    </div>
    <!-- <div class="step-btn">
      <el-button :disabled="current===0" @click="pre">上一步</el-button>
      <el-button v-if="current<3" type="primary" :loading="btnload" @click="next">下一步</el-button>
      <el-button v-if="current===3" type="primary" @click="finish">完成</el-button>
    </div> -->
  </div>
</template>
<script>
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination
  },
  props: {
    steps: {
      type: Array,
      required: true
    },
    stepList: {
      type: Array,
      required: true
    },
    ruleForm: {
      type: Object,
      default: function() {
        return {
          tradeOrgId: '',
          linkMan: '',
          linkPhone: ''
        }
      }
    },
    bidData: {
      type: Array,
      required: true
    },
    bidTotal: {
      type: Number,
      required: true
    },
    bidQuery: {
      type: Object,
      required: true
    },
    seatData: {
      type: Array,
      required: true
    },
    seatTotal: {
      type: Number,
      required: true
    },
    seatQuery: {
      type: Object,
      required: true
    },
    monitorData: {
      type: Array,
      required: true
    },
    monitorTotal: {
      type: Number,
      required: true
    },
    monitorQuery: {
      type: Object,
      required: true
    },
    flag: {
      type: Boolean,
      required: true
    }
  },
  data() {
    const checkPhone = (rule, value, callback) => {
      // 验证手机号的正则表达式
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
      if (regMobile.test(value)) {
        return callback()
      }
      callback(new Error('请输入合法的手机号'))
    }
    return {
      current: 0,
      status: 'process',
      active: 0,
      allStepts: false,
      btnload: false,
      // ruleForm: {
      //   tradeOrgId: vm.$store.state.user.userinfo.orgInfo.orgId,
      //   linkMan: '',
      //   linkPhone: ''
      // },
      rules: {
        linkMan: [
          { required: true, message: '请输入场地联系人', trigger: 'blur' }
        ],
        linkPhone: [
          { required: true, validator: checkPhone, trigger: 'blur' }
        ]
      },
      orgId: '',
      result: []
    }
  },
  watch: {
    current(val) {
      this.active = val
      if (val === 1) {
        // 获取场地数据
        this.getBidData()
      } else if (val === 2) {
        // 获取机位数据
        this.getSeatData()
      } else if (val === 3) {
        // 获取监控数据
        this.getMonitorData()
      }
    }
  },
  activated() {
    // 重置节点位置
    this.active = 0
    this.current = 0
    // this.getSteps()
  },
  methods: {
    // 步骤条上一步的方法
    // pre() {
    //   if (this.active-- < 2) this.active = 0
    // },
    prev() {
      this.current--
    },
    next() {
      if (this.current === 0) {
        this.btnload = true
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            // this.active++
            const params = {
              tradeOrgId: this.ruleForm.tradeOrgId,
              linkMan: this.ruleForm.linkMan,
              linkPhone: this.ruleForm.linkPhone
            }
            this.$http.post(`/evalRoomManages/save`, params).then(res => {
              if (res.data.code === '1') {
                this.$message.success(res.data.msg)
                setTimeout(() => {
                  this.btnload = false
                  // this.active++
                  this.current++
                }, 2000)
              } else {
                this.$message.error(res.data.msg)
                this.btnload = false
              }
            })
          } else {
            this.btnload = false
            return false
          }
        })
      } else this.current++
      // if (this.active++ > 3) this.active = 0
    },
    changeValue() {
    },
    stepChange(current) {
      // 当前点击的先转string类型去查询是否存在；存在后转回number类型去跳转对应节点
      current = current + ''
      if (this.flag === true && this.stepList.includes(current)) {
        this.current = Number(current) - 1
        // this.active = Number(current) - 1
      }
    },
    // 完成
    finish() {
      this.current = 0
      this.active = 0
    },
    // 获取场地数据
    getBidData() {
      this.$emit('getBidData')
    },
    // 场地编辑
    openUpdate(id) {
      this.$emit('openUpdate', id)
    },
    // 场地删除
    handleDelete(id) {
      this.$emit('handleDelete', id)
    },
    // 获取机位数据
    getSeatData() {
      this.$emit('getSeatData')
    },
    // 机位编辑
    openSeatUpdate(row) {
      this.$emit('openSeatUpdate', row)
    },
    // 机位删除
    handleSeatDelete(row) {
      this.$emit('handleSeatDelete', row)
    },
    // 机位状态
    handleSeatClose(row) {
      this.$emit('handleSeatClose', row)
    },
    // 获取监控数据
    getMonitorData() {
      this.$emit('getMonitorData')
    },
    // 监控编辑
    openMonitorUpdate(row) {
      this.$emit('openMonitorUpdate', row)
    },
    // 监控删除
    handleMonitorDelete(row) {
      this.$emit('handleMonitorDelete', row)
    }
  }
}
</script>
<style lang="less" scoped>
.step{
  /deep/.ant-steps-item-icon{
    height:30px;
    width: 30px;
    line-height: 30px;
  }
  .step-list{
    padding: 0 200px;
  }
  .info-base{
    // height: 216px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #D8D8D8;
    // margin:32px;
    margin:32px 32px 24px 32px;
    padding:24px 32px 8px 32px;
    .open:before{
      content: '';
      position: absolute;
      width: 6px;
      height: 6px;
      background: #1890FF;
      border-radius: 50%;
      top: 20px;
      margin-left: -10px;
    }
    .close:before{
      content: '';
      position: absolute;
      width: 6px;
      height: 6px;
      background: #F23030;
      border-radius: 50%;
      top: 20px;
      margin-left: -10px;
    }
    .base-form{
      width: 44%;
      margin: 0 auto;
    }
    .info-base-table{
      margin:16px 0px 16px 55px
    }
    .over{
      margin: 16px 0px 16px 70px;
    }

  }
  .step-btn{
    width: 300px;
    margin: 0 auto;
  }
  /deep/.is-success{
    color: #1890FF;
    border-color: #1890FF;
  }
  /deep/.el-step__title.is-success{
    color: rgba(0, 0, 0, 0.85);
  }
  /deep/.is-finish{
     color:#fff;
     border:none;
    // color: #c0c4cc;
    // border-color: #c0c4cc;
  }
  /deep/.is-finish>.el-step__icon.is-text{
    background:#1890FF
  }
  /deep/.el-step__title.is-finish{
    color: rgba(0, 0, 0, 0.85);
  }
  /deep/.is-wait>.el-step__icon.is-text{
    color:#fff
  }
  /deep/.is-wait>.el-step__icon:before {
    content: ">";
    color:#ccc;
    position: absolute;
    top:3px
  }
   /deep/.el-step__head>.el-step__line{
    // margin:0 30px!important;
    margin-left: 30px;
    margin-right: 10px!important;
  }
}

</style>
